const initNetlifyIdentity = () => {
  const script = document.createElement("script");
  script.src = "https://identity.netlify.com/v1/netlify-identity-widget.js";
  script.async = true;
  document.body.appendChild(script);
};

export default initNetlifyIdentity;
